import { THRIVE_REPORT_BUG_URL } from "@healthos/shared";
import { Modal, ModalDescription, ModalFooter, ModalTitle } from "@healthos/ui";
import { X } from "@phosphor-icons/react";
import { externalLinkClickHandler } from "./external-link";

export function ReportBugConfirmModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} size="sm">
      <div className="flex items-start justify-between gap-5 px-6 pt-6 pb-5">
        <div>
          <ModalTitle className="sr-only">Leaving HealthOS</ModalTitle>
          <ModalDescription className="m-0 text-sm leading-6 text-ink-primary/80">
            This link will open outside of the Thrive application.
          </ModalDescription>
        </div>
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          aria-label="Close"
          className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-border-soft bg-surface-elevated text-ink-tertiary transition-colors hover:bg-cream hover:text-ink-primary"
        >
          <X size={16} weight="bold" />
        </button>
      </div>
      <ModalFooter className="justify-center">
        <a
          href={THRIVE_REPORT_BUG_URL}
          target="_blank"
          rel="noreferrer"
          onClick={externalLinkClickHandler(THRIVE_REPORT_BUG_URL, () => onOpenChange(false))}
          className="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-teal-700 px-[18px] text-xs font-sans font-medium text-ink-on-brand no-underline shadow-button transition-colors hover:bg-teal-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
        >
          Continue <span aria-hidden="true">→</span>
        </a>
      </ModalFooter>
    </Modal>
  );
}
